/**
 * CUSTOM TABLE BODY - WRAPPER
 *
 * This component extends CustomTableBody to add extra request parameters: sortBy, direction.
 * CustomTableBody code base is left the same when being overwritten with the exception of adding the extra params.
 *
 * @version 0.1
 */

import React from 'react';
import { isEqual, isEqualWith } from 'lodash';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import {POST} from './../../constants';
import CustomTableBody from './../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import api from './redux/CustomTableBodyPostParamsWrapper.api';

export default class CustomTableBodyPostParamsWrapper extends CustomTableBody {

    constructor(props) {
        super(props);

        this.sortBy = 'createdDate';
        this.direction = props.tableRequestPayload.direction ? props.tableRequestPayload.direction : 'desc';
    }

    componentWillMount() {

        this.addRowsToTable(
            this.url,
            this.pageNumber,
            this.pageSize,
            this.sortBy,
            this.direction,
            this.props.urlParams,
            this.showSpinner,
            this.hideSpinner,
            this.dataStore,
            this.props.tableRequestPayload
        );

    }

    componentWillReceiveProps(nextProps) {

        if (!isEqual(this.props.urlParams, nextProps.urlParams) ||
            !isEqual(this.props.tableRequestPayload, nextProps.tableRequestPayload) ||
            this.props.url !== nextProps.url) {

            if (!this.props.preventScrollToTop) {
                window.scrollTo(0, 0);
            }

            let clearEntries = true;
            this.pageNumber = 0;
            this.endReached = false;
            this.url = nextProps.url;

            this.dataStore = nextProps.dataStore;

            if (this.props.innerTable && this.rootDOMNode) {
                this.rootDOMNode.removeEventListener('scroll', this.scrollHandler);
            }

            this.addRowsToTable(
                this.url,
                this.pageNumber,
                this.pageSize,
                this.sortBy,
                this.direction,
                nextProps.urlParams,
                this.showSpinner,
                this.hideSpinner,
                this.dataStore,
                nextProps.tableRequestPayload,
                clearEntries
            ).then((response) => {
                if (this.props.innerTable) {
                    this.addInfiniteScroll();
                }
            });
        }
    }

    addRowsToTable(url = '',
                   pageNumber = '',
                   pageSize = '',
                   sortBy = '',
                   direction = '',
                   urlParams,
                   showSpinner,
                   hideSpinner,
                   dataStore,
                   tableRequestPayload,
                   clearEntries = false) {

        if (this.endReached) { return; }

        if (clearEntries) {
            this.setState({
                emptyCellMessageId: this.props.emptyCellMessageId,
                entries:            [],
                noEntries:          false
            });
        }

        if (this.props.innerTable && this.rootDOMNode) {
            this.rootDOMNode.classList.add('in-loading-mode');
        }

        showSpinner();

        this.addingRows = true;
        this.requestParams = api.buildQueryParamsCompanyArticlesPage(pageNumber, pageSize, sortBy, direction, urlParams);
        this.requestData = tableRequestPayload;
        this.url = url;

        return api.getTableDataCompanyArticlesPage(
            url,
            pageNumber,
            pageSize,
            sortBy,
            direction,
            urlParams,
            dataStore,
            this.verb,
            tableRequestPayload
        ).then(
            (response) => {

                if (!this.tableIsMounted) {
                    return;
                }

                let compareFunction = (a, b) => {
                    for (let key in a) {
                        if (a.hasOwnProperty(key) && a[key] != b[key])
                            return false;
                    }

                    return true;
                };

                if (response.req) {
                    let baseUrl     = response.req.url.substring(0, response.req.url.indexOf('?'));

                    if (baseUrl !== this.url) {
                        console.log("WARN: Ignoring out of order paged request: url mismatch");
                        console.log(baseUrl);
                        console.log(this.url);
                        return;
                    }

                    if (response.req.method !== this.verb) {
                        console.log("WARN: Ignoring out of order paged request: verb mismatch");
                        console.log(response.req.method);
                        console.log(this.verb);
                        return;
                    }

                    let queryParams = api.splitQueryParams(response.req.url);

                    if (!isEqualWith(this.requestParams, queryParams, compareFunction)) {
                        console.log("WARN: Ignoring out of order paged request: query param mismatch");
                        console.log(this.requestParams);
                        console.log(queryParams);
                        return;
                    }

                    if (this.verb === POST) {
                        if (!isEqualWith(response.req._data, this.requestData, compareFunction)) {
                            console.log("WARN: Ignoring out of order paged request: body mismatch");
                            console.log(response.req._data);
                            console.log(this.requestData);
                            return;
                        }
                    }

                }

                var newEntries;

                if (utils.isArray(response.body)) {
                    newEntries = response.body;
                } else if (utils.isArray(response.body[this.props.nestedObject])) {
                    newEntries = response.body[this.props.nestedObject];
                } else if (response.body[this.props.nestedObject] == null) {
                    newEntries = [];
                } else {
                    throw new TypeError('The response is expected to be an array. ' +
                        Object.prototype.toString.call(newEntries) + ' given instead.');
                }

                if (!newEntries || newEntries.length < parseInt(pageSize, 10)) {
                    this.endReached = true;
                }

                // Execute the "justBeforeAddingEntries" lifecycle event handler if any
                if (utils.isObject(this.props.lifecycleEvents) &&
                    typeof this.props.lifecycleEvents.justBeforeAddingEntries === 'function') {
                    this.props.lifecycleEvents.justBeforeAddingEntries(response, this);
                }

                this.setState(
                    Object.assign(
                        {},
                        this.state,
                        {entries: [...this.state.entries, ...newEntries]}
                    )
                );

                if (this.endReached && this.state.entries.length === 0) {
                    this.setState(
                        Object.assign(
                            {},
                            this.state,
                            {noEntries: true}
                        )
                    );
                }

                // Execute the "finishedAddingEntries" lifecycle event handler if any
                if (utils.isObject(this.props.lifecycleEvents) &&
                    typeof this.props.lifecycleEvents.finishedAddingEntries === 'function') {
                    this.props.lifecycleEvents.finishedAddingEntries(response, this);
                }

                this.addingRows = false;

                hideSpinner();

                if (this.props.innerTable && this.rootDOMNode) {
                    this.rootDOMNode.classList.remove('in-loading-mode');
                }

                if (dataStore) {
                    this.endReached = true;
                    if (this.props.datastoreSpinner === true) this.showSpinner();
                    if (this.props.datastoreSpinner === false) this.hideSpinner();
                }

            }
        ).catch((error) => {
            utils.logError(error, 'CustomTableBody.index.addRowsToTable():');
            xhr.handleAllErrors(error);
        });

    }

    addInfiniteScroll() {

        let tableBody = this.rootDOMNode;
        this.scrolledElement = this.props.innerTable ? tableBody : window;

        this.scrollHandler = (event) => {

            let bottomScrollOffset = 600,
                shouldAddNewRows   = false;

            if (this.props.innerTable) {
                let bottomDistance = tableBody.scrollHeight - tableBody.scrollTop - tableBody.clientHeight;
                shouldAddNewRows = bottomDistance < bottomScrollOffset;
            } else {
                this.toggleFixedHeader();

                let pageY = (window.scrollY || window.pageYOffset);
                shouldAddNewRows = (document.body.offsetHeight - bottomScrollOffset) < (window.innerHeight + pageY);
            }

            if (shouldAddNewRows && !this.addingRows) {

                this.pageNumber++;
                this.addingRows = true;

                this.addRowsToTable(
                    this.url,
                    this.pageNumber,
                    this.pageSize,
                    this.sortBy,
                    this.direction,
                    this.props.urlParams,
                    this.showSpinner,
                    this.hideSpinner,
                    this.dataStore,
                    this.props.tableRequestPayload
                );

            }

        };

        this.scrolledElement.addEventListener('scroll', this.scrollHandler);

    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/CustomTableBody/CustomTableBodyPostParamsWrapper.jsx